import { WithdrawalsLimitsRecord } from '@types';

import { WithdrawalsSetLimitsLimitTypeReducer } from './types';

export const withdrawalsSetLimitsLimitTypeReducer: WithdrawalsSetLimitsLimitTypeReducer =
  (state, action) => {
    const { limitId, limitType } = action.payload;

    const limitToUpdate = state.withdrawalsLimitsProcessedItems?.[limitId];

    if (!limitToUpdate) {
      return state;
    }

    const updatedItem: WithdrawalsLimitsRecord = {
      [limitId]: {
        ...limitToUpdate,
        limitType,
      },
    };

    return {
      ...state,
      withdrawalsLimitsProcessedItems: {
        ...state.withdrawalsLimitsProcessedItems,
        ...updatedItem,
      },
    };
  };
